import Vue from 'vue';

export default {
  state: {
    statuses: [],
  },
  getters: {
    statuses(state) {
      return state.statuses;
    },
    // eslint-disable-next-line
    status: state => (id) => {
      return state.statuses.find(status => status.id === id) || {};
    },
  },
  mutations: {
    SET_STATUSES(state, payload) {
      state.statuses = payload;
    },
  },
  actions: {
    GET_STATUSES(context) {
      return Vue.axios.get('status').then((response) => {
        context.commit('SET_STATUSES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/status.js